import React, { useEffect, useRef, useState } from "react";
import clientImage1 from "../landing-page/images/client-img1.png";
import clientImage2 from "../landing-page/images/client-img2.png";
import clientImage3 from "../landing-page/images/client-img3.png";
import starImage from "../landing-page/images/star-img.png";
import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";
import "../landing-page/css/style.css";
import "../landing-page/css/owl.carousel.css";
import "../landing-page/css/media.css";
import { Carousel, Radio } from "antd";

const reviews = [
  {
    name: "Omar D.",
    image: clientImage1,
    rating: 5,
    review:
      "I placed bets on Txtbet during last weekend's football matches while hanging out with my buddies, and it was seamless! Everyone was impressed with how quick and easy it was to navigate the app. I even managed to show them a few winning tricks.",
  },
  {
    name: "John F.",
    image: clientImage2,
    rating: 5,
    review:
      "My wife was skeptical about betting apps, but after we used Txtbet together for a horse race, she was amazed by how well customer service handled our payout question. Now she jokes about splitting winnings to cover her shopping.",
  },
  {
    name: "Mandy A.",
    image: clientImage3,
    rating: 5,
    review:
      "I used Txtbet during a live cricket match and couldn't believe the bonus I got on my first bet. It was like doubling my chances with zero extra effort! Even my brother, who's new to betting, jumped in and had a blast with the offers.",
  },
  {
    name: "Alice B.",
    image: clientImage1,
    rating: 4,
    review:
      "I placed bets on Txtbet during last weekend's football matches while hanging out with my buddies, and it was seamless! Everyone was impressed with how quick and easy it was to navigate the app. I even managed to show them a few winning tricks.",
  },
  {
    name: "Michael T.",
    image: clientImage2,
    rating: 5,
    review:
      "My wife was skeptical about betting apps, but after we used Txtbet together for a horse race, she was amazed by how well customer service handled our payout question. Now she jokes about splitting winnings to cover her shopping.",
  },
  {
    name: "Mandy A.",
    image: clientImage3,
    rating: 5,
    review:
      "I used Txtbet during a live cricket match and couldn't believe the bonus I got on my first bet. It was like doubling my chances with zero extra effort! Even my brother, who's new to betting, jumped in and had a blast with the offers.",
  },
];

// Function to split reviews into chunks
const chunkArray = (array, size) => {
  return array.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(array.slice(i, i + size));
    return acc;
  }, []);
};

// const ClientReviews = () => {
//   const [slidesToShow, setSlidesToShow] = useState(3);

//   useEffect(() => {
//     const updateSlidesToShow = () => {
//       if (window.innerWidth >= 1200) {
//         setSlidesToShow(3);
//       } else if (window.innerWidth >= 768) {
//         setSlidesToShow(2);
//       } else {
//         setSlidesToShow(1);
//       }
//     };

//     updateSlidesToShow();
//     window.addEventListener("resize", updateSlidesToShow);
//     return () => window.removeEventListener("resize", updateSlidesToShow);
//   }, []);

//   const groupedReviews = chunkArray(reviews, slidesToShow);

//   // useEffect(() => {
//   //   const updateItemsPerPage = () => {
//   //     const width = window.innerWidth;
//   //     if (width >= 1024) {
//   //       setItemsPerPage(3);
//   //     } else if (width >= 768) {
//   //       setItemsPerPage(2);
//   //     } else {
//   //       setItemsPerPage(1);
//   //     }
//   //   };

//   //   updateItemsPerPage();
//   //   window.addEventListener("resize", updateItemsPerPage);
//   //   return () => window.removeEventListener("resize", updateItemsPerPage);
//   // }, []);

//   // const totalSlides = Math.ceil(reviews.length / itemsPerPage);
//   // const maxIndex = totalSlides - 1;

//   // const handleNext = () => {
//   //   setCurrentIndex((prev) => (prev < maxIndex ? prev + 1 : 0));
//   // };

//   // const handlePrev = () => {
//   //   setCurrentIndex((prev) => (prev > 0 ? prev - 1 : maxIndex));
//   // };

//   // useEffect(() => {
//   //   const interval = setInterval(() => {
//   //     handleNext();
//   //   }, autoSlideInterval);

//   //   return () => clearInterval(interval);
//   // }, [currentIndex]);

//   return (
//     <section className="client-reviews wow fadeInUp">
//       <div className="fixed-wrapper !w-screen">
//         <div className="xl:!text-5xl lg:!text-[40px] md:!text-[30px] !text-[22px] font-bold text-center">
//           Happy Customers
//         </div>
//         <div className="mt-10 !relative !w-full">
//           <Carousel
//             arrows
//             prevArrow={<GrPrevious size={40} className="custom-prev" />}
//             nextArrow={<GrNext size={40} className="custom-next" />}
//             dotPosition="bottom"
//             className="!relative"
//           >
//             {groupedReviews.map((group, index) => (
//               <div key={index} className="!flex !gap-10">
//                 {group.map((review, idx) => (
//                   <div key={idx} className="review-box">
//                     <div className="review-box-title">
//                       <figure>
//                         <img src={review.image} alt={review.name} />
//                       </figure>
//                       <div className="review-box-title-cont text-5xl">
//                         <div className="text-2xl font-bold">{review.name}</div>
//                         <ul className="rating !flex">
//                           {[...Array(review.rating)].map((_, i) => (
//                             <li key={i}>
//                               <img src={starImage} alt="star" />
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="text-lg mt-5">{review.review}</div>
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </Carousel>
//         </div>

//         {/* <div className="owl-nav flex flex-row justify-center gap-5 mt-10">
//           <button
//             type="button"
//             className="owl-prev bg-white hover:bg-[#0944a1] p-4 rounded-full hover:text-white"
//             onClick={handlePrev}
//           >
//             <GrPrevious size={27} className="hover:text-white" />
//           </button>
//           <button
//             type="button"
//             className="owl-next bg-white hover:bg-[#0944a1] hover:text-white p-4 rounded-full"
//             onClick={handleNext}
//           >
//             <GrNext size={27} className="hover:text-white" />
//           </button>
//         </div> */}
//       </div>
//     </section>
//   );
// };

const ClientReviews = () => {
  const [slidesToShow, setSlidesToShow] = useState(3);
  const carouselRef = useRef(null);

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth >= 1200) {
        setSlidesToShow(3);
      } else if (window.innerWidth >= 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);

  const groupedReviews = chunkArray(reviews, slidesToShow);
  const [currentIndex, setCurrentIndex] = useState(0);
  console.log();
  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === groupedReviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? groupedReviews.length - 1 : prevIndex - 1
    );
  };
  return (
    <section className="client-reviews wow fadeInUp relative w-full">
      <div className="fixed-wrapper w-screen">
        <div className="xl:text-5xl lg:text-[40px] md:text-[30px] text-[22px] font-bold text-center">
          Happy Customers
        </div>
        <div className="relative w-full mt-10">
          <div className="overflow-hidden px-4">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {groupedReviews.map((group, index) => (
                <div
                  key={index}
                  className="min-w-full flex gap-4 px-9 select-none"
                >
                  {group.map((review, idx) => (
                    <div key={idx} className="review-box">
                      <div className="review-box-title">
                        <figure>
                          <img src={review.image} alt={review.name} />
                        </figure>
                        <div className="review-box-title-cont text-5xl">
                          <div className="text-2xl font-bold">
                            {review.name}
                          </div>
                          <ul className="rating flex">
                            {[...Array(review.rating)].map((_, i) => (
                              <li key={i}>
                                <img src={starImage} alt="star" />
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="text-lg mt-5">{review.review}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
            onClick={prevSlide}
          >
            <GrPrevious
              size={window.innerWidth > 500 ? 30 : 20}
              className="!text-white"
            />
          </button>
          <button
            className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
            onClick={nextSlide}
          >
            <GrNext
              size={window.innerWidth > 500 ? 30 : 20}
              className="!text-white"
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ClientReviews;
